import React, { useState, useEffect } from "react";
import Sidebar from "../Layout/Sidebar";
import Loading from "react-fullscreen-loading";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { useNavigate } from "react-router-dom";
import { callAxios } from "../../utils/axios";
import { toastMessage } from "../../utils/toast";
import { useConfirm } from "material-ui-confirm";
import { MenuItem, Select, Switch, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import moment from "moment";
import { useTranslation } from "react-i18next";
const CustomTableHeadCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#fff", // Customize cell background color
  fontWeight: "bold", // Customize cell text styling
  fontFamily: "Poppins",
  fontSize: "16px",
  lineHeight: "24px",
  borderBottom: "none",
  color: "black",
}));
const CustomTableBodyCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#F4F4F4", // Customize cell background color
  fontFamily: "Poppins",
  fontSize: "16px",
  lineHeight: "24px",
  borderBottom: "none",
}));

const CustomTableHeadRow = styled(TableRow)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "#E0E0E0",
  },
  border: "none",
}));
const CustomTableBodyRow = styled(TableRow)(({ theme }) => ({
  marginBottom: "10px",
}));

const OrderManagement = () => {
  const {t} = useTranslation()
  const navigate = useNavigate();
  const confirm = useConfirm();

  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [orders, setOrders] = useState([] as any);

  const getAllProducts = async () => {
    try {
      setLoading(true);
      const { data } = await callAxios("get", "order/getDistributorOrders");
      console.log(data);
      setOrders(data?.orders);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      toastMessage(
        error?.response?.data?.message || "Something went wrong.",
        "error"
      );
    }
  };

  useEffect(() => {
    getAllProducts();
  }, [checked]);

  return (
    <>
      <Loading loading={loading} background="#fff" loaderColor="#719FE5" />
      <Sidebar>
        <div className="py-6 px-4 flex flex-col gap-8">
          <div className="w-full flex justify-between items-center">
            <div className="flex flex-col gap-2">
              <h1 className="text-[#23282D] poppins text-3xl font-semibold tracking-tight ">
              {t('DistributerRoute.orderManagementPage.title')}
              </h1>
              <p className="inter tracking-tight text-sm color-[#23282D]">
              {t('DistributerRoute.orderManagementPage.description')}              </p>
            </div>
          </div>
          <div className="w-full flex flex-col gap-3 ">
            <div className="w-full bg-white p-3 rounded shadow">
              <Table
                sx={{
                  borderSpacing: "0 15px !important",
                  borderCollapse: "separate !important",
                }}
              >
                <TableHead>
                  <CustomTableHeadRow>
                    {/* <CustomTableHeadCell>ORDER NUMBER</CustomTableHeadCell> */}
                    {/* <CustomTableHeadCell>DEALER NAME</CustomTableHeadCell> */}

                    <CustomTableHeadCell>{t('DistributerRoute.orderManagementPage.tableHeaders.address')}  </CustomTableHeadCell>
                    <CustomTableHeadCell>{t('DistributerRoute.orderManagementPage.tableHeaders.price')} </CustomTableHeadCell>
                    <CustomTableHeadCell>{t('DistributerRoute.orderManagementPage.tableHeaders.status')}</CustomTableHeadCell>
                    <CustomTableHeadCell>{t('DistributerRoute.orderManagementPage.tableHeaders.orderDate')}</CustomTableHeadCell>
                  </CustomTableHeadRow>
                </TableHead>
                <TableBody>
                  {orders.map((order: any) => {
                    return (
                      <CustomTableBodyRow
                        sx={{
                          marginBottom: "10px !important",
                        }}
                        key={order?._id}
                      >
                        {/* <CustomTableBodyCell
                          sx={{
                            borderTopLeftRadius: "10px",
                            borderBottomLeftRadius: "10px",
                          }}
                        >
                          {order.skuName}
                        </CustomTableBodyCell> */}
                        {/* <CustomTableBodyCell>
                          {order?.skuCode}
                        </CustomTableBodyCell> */}
                        {/* <CustomTableBodyCell>
                          {order?.distributor?.name}
                        </CustomTableBodyCell> */}
                        <CustomTableBodyCell>
                          {order?.address?.name}
                        </CustomTableBodyCell>
                        <CustomTableBodyCell>
                          {order?.totalPrice}
                        </CustomTableBodyCell>
                        <CustomTableBodyCell>
                          {order?.status?.toUpperCase()}
                        </CustomTableBodyCell>
                        <CustomTableBodyCell>
                          {moment(order?.createdAt).format("DD.MM.YYYY")}
                        </CustomTableBodyCell>
                        <CustomTableBodyCell
                          sx={{
                            borderTopRightRadius: "10px",
                            borderBottomRightRadius: "10px",
                          }}
                        ></CustomTableBodyCell>
                      </CustomTableBodyRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          </div>
        </div>
      </Sidebar>
    </>
  );
};

export default OrderManagement;
